const steps = [
  {
    icon: "ri-file-edit-line",
    title: "填写站点信息",
    desc: "给出站点名称、所属分类和一句话简介，越具体越方便我们判断。",
  },
  {
    icon: "ri-eye-line",
    title: "人工实际体验",
    desc: "我们会真的打开用一遍，确认能正常访问、内容对得上再决定是否收录。",
  },
  {
    icon: "ri-list-check-2",
    title: "通过后进入列表",
    desc: "收录后站点会出现在对应分类里，后续若内容变味会被巡检下架。",
  },
];

export default function SubmitSection() {
  return (
    <section id="submit" className="scroll-mt-20">
      <div className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-shell">
          <div className="relative overflow-hidden rounded-lg border border-primary-700">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20flowing%20warm%20gradient%20shapes%20in%20amber%20and%20clay%20tones%2C%20soft%20film%20grain%2C%20minimal%20editorial%20background%2C%20smooth%20curved%20layered%20forms%2C%20muted%20warm%20palette&width=1600&height=560&seq=submit-band-2026&orientation=landscape"
              alt="51网址导航收录申请背景"
              title="51网址导航收录申请 · 分类收录站点列表"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-900/85 to-primary-800/70"></div>

            <div className="relative z-10 px-6 md:px-10 py-10 md:py-14">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 border border-background-50/30 text-xs md:text-sm text-background-50">
                  <i className="ri-add-circle-line"></i>
                  收录申请
                </span>
                <h2 className="mt-4 font-heading text-2xl md:text-3xl font-semibold text-background-50">
                  有好站想推荐给更多人？
                </h2>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-background-100">
                  自主收录、人工核对、不收费用。把你常去却没被收录的站点告诉我们，通过后会进入对应分类的列表里。
                </p>
              </div>

              <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {steps.map((step, index) => (
                  <div
                    key={step.title}
                    className="p-5 rounded-lg bg-background-50/12 border border-background-50/25 backdrop-blur-sm"
                  >
                    <div className="flex items-center gap-3">
                      <span className="w-10 h-10 rounded-lg bg-background-50 text-primary-700 flex items-center justify-center">
                        <i className={`${step.icon} text-lg`}></i>
                      </span>
                      <span className="font-label text-sm text-accent-200">
                        第 {index + 1} 步
                      </span>
                    </div>
                    <h3 className="mt-3 font-heading text-base font-semibold text-background-50">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-background-100/90">
                      {step.desc}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-9 flex flex-col sm:flex-row items-center gap-4">
                <a
                  href="#submit"
                  className="flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 rounded-md bg-background-50 text-primary-800 text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                  提交收录申请
                </a>
                <span className="text-sm text-background-100/90">
                  也可以先看看
                  <a href="#faq" className="underline underline-offset-4 ml-1 cursor-pointer">
                    常见问题
                  </a>
                  ，了解收录标准
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}